import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

const rowStyled = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
};

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    ...rowStyled,
    boxSizing: "border-box",
    justifyContent: "space-between",
    borderRadius: theme.radius.small,
    padding: `${theme.spacing.space8}px ${theme.spacing.space12}px`,
    minHeight: 76,
  },
  content: {
    ...rowStyled,
    gap: theme.spacing.space12,
    textAlign: "start",
  },
  icon: {
    color: theme.colors.TextDefault,
  },
}));
